module.exports = __webpack_public_path__ + "static/media/vigold.6d3c074d.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/pimiento/climasense/cenicilla_pimiento/curativa/vigold.png
// module id = 2203
// module chunks = 3